import MainLayout from '../../layouts/MainLayout';
import React from 'react';
import RequireAuth from '../../guards/RequireAuth';
import { Route } from 'react-router';
import Tasks from './Tasks';

const Routes = (
  <Route
    path="/system"
    element={
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    }
  >
    <Route path="/system/tasks" element={<Tasks />} />
  </Route>
);

export default Routes;
